<template>
  <div id="app">
    <router-view></router-view>
    <!-- <img alt="Vue logo" src="./assets/logo.png">
    <HelloWorld msg="Welcome to Your Vue.js App"/> -->
  </div>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'
export default {
  name: 'App',
  // created() {
  //   this.postMessage();
  // },
  // methods: {
  //   getCookie(name) {
  //     return document.cookie
  //       .split('; ')
  //       .find(row => row.startsWith(`${name}=`))
  //       ?.split('=')[1];
  //   },
  //   postMessage() {
  //     const token = this.getCookie('user-token') || this.$store.state.token; //读取认证中心的令牌Token
  //     console.log('app' + token)
  //     if(token) {
  //       window.parent.postMessage(
  //         JSON.stringify({ ticket: token }),
  //         '*'
  //       );
  //     }
  //   }
  // },
  components: {
    // HelloWorld
  }
};
</script>

<style>
html,
body {
  height: 100%;
  margin: 0;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
  /* margin-top: 60px; */
}
</style>
